import { useState, useMemo } from 'react';
import { NudosGenericModal, NudosModalContent } from '../../../../../../components/NudosComponents';
import useConfigurationGlobalState from '../configurationGlobalState';
import ToolsAsociatedConfigModalContent from './ToolsAsociatedConfigModalContent';
import './ToolsAsociatedConfigModal.scss';

const ToolsAsociatedConfigModal = ({ closeModalCallback }: { closeModalCallback: () => void }) => {
  const { configUnit } = useConfigurationGlobalState();

  
  const [searchText, setSearchText] = useState('');

  const filteredUnits = useMemo(() => {
    if (!searchText) return configUnit?.tools;

    const searchLower = searchText.toLowerCase();
    return configUnit?.tools?.filter(
      unit => unit.name.toLowerCase().includes(searchLower) || unit.serial.toLowerCase().includes(searchLower)
    );
  }, [searchText]);

  return (
    <NudosGenericModal
      customClassName="toolsAsociatedConfigModal"
      closeModalCallback={closeModalCallback}
      modalContent={
        <NudosModalContent
          customHeaderClass="ml-32"
          customWidth="580px"
          customHeight="446px"
          modalContentTitle="Unidades con configuración"
          startHeader
          toCloseModal={closeModalCallback}
          CustomModalComponent={
            <ToolsAsociatedConfigModalContent
              filteredUnits={filteredUnits ?? []}
              searchText={searchText}
              setSearchText={setSearchText}
            />
          }
        />
      }
    />
  );
};

export default ToolsAsociatedConfigModal;
